import React from "react";
import styled from "styled-components";
import Container from "storybook-components/Container";
import { H3, Body, ButtonTxtStyle } from "storybook-components/Typography";
import LinkArrow from "./images/link-arrow.svg";

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gray1};
  padding: 48px 16;
  ${props => props.theme.media.desktopUp`
    padding: 120px 0;
  `};
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ theme }) => theme.media.desktopUp`
    flex-direction: row;
  `}
`;

const ContentColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 2rem 0;
  ${({ theme }) => theme.media.desktopUp`
    padding: 0;
    width: 50%;
  `}
`;
const Heading = styled(H3)`
  color: ${({ theme }) => theme.colors.green5};
  ${({ theme }) => theme.media.desktopUp`
    margin: 0 0 24px;
    max-width: 480px;
  `};
`;

const StyledBody = styled(Body)`
  color: ${({ theme }) => theme.colors.green5};
  ${({ theme }) => theme.media.desktopUp`
    margin: 0 0 24px;
    max-width: 480px;
  `};
`;

const StyledArrowAnchor = styled.a`
  ${ButtonTxtStyle};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  :after {
    content: "";
    width: 24px;
    height: 12px;
    display: inline-block;
    background-image: url(${LinkArrow});
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: right;
  }
  color: ${({ theme }) => theme.colors.green5};
  ${({ theme }) => theme.media.desktopUp`
    margin: 0 0 24px;
    max-width: 480px;
  `};
`;
export default ({ heading, bodyCopy, linkText, linkDestination, image }) => {
  return (
    <Wrapper>
      <StyledContainer>
        <ContentColumn>
          <Heading>{heading}</Heading>
          <StyledBody>{bodyCopy}</StyledBody>
          <StyledArrowAnchor href={linkDestination}>
            {linkText}
          </StyledArrowAnchor>
        </ContentColumn>
        <ContentColumn>
          <img src={image} />
        </ContentColumn>
      </StyledContainer>
    </Wrapper>
  );
};
